import * as React from 'react';
import MuiCheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import MuiHighlightOffIcon from '@material-ui/icons/HighlightOff';
import MuiBackupOutlinedIcon from '@material-ui/icons/BackupOutlined';

export default function DistributionStatusIcon({ status }) {
  return (
    <>
      {status === 'Sent to DSP' && <MuiCheckCircleOutlineIcon style={{ color: `#82b182` }} fontSize="small" />}
      {status === 'Failed to send to DSP' && <MuiHighlightOffIcon color="error" fontSize="small" />}
      {['Queued', 'In Progress', 'Cancelled'].includes(status) && (
        <MuiBackupOutlinedIcon color="disabled" fontSize="small" />
      )}
    </>
  );
}
